<template>
  <!--<div id="indexBox">-->
  <!--<el-container class="wmCloudsWrapper">-->
  <!--<app-header></app-header>-->
  <!--<div id="layoutMainMail">-->
    <el-container class="wmCloudsContant">
      <!-- 邮箱左侧导航 -->
      <!--<app-aside></app-aside>-->
      <!-- 设置左侧导航 -->
      <asideSet></asideSet>
      <el-container>
      <div class="flexbox wmCloudsMain">
      <div class="wmCloudsBox">
      <!-- 操作栏 -->
      <!--<actionBar></actionBar>-->
      <!-- 设置页面包屑导航 -->
      <!--<setBreadNav></setBreadNav>-->
      <!-- 如下代码需要做判断，如果是首页加homeCloudsCount CLASS；其它页面加wmCloudsCount  CLASS -->
      <div class="setBreadNav flexBetween">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item v-for="(item, index) in getBreadcrumb" :key="index">{{item}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="flexbox wmCloudsCount homeCloudsCount">
      <!-- 邮件列表 -->
      <!--<listBar></listBar>-->
      <!-- view内容区 -->
      <div class="mainBar nice_scroll">
      <transition mode="out-in">
      <router-view></router-view>
      </transition>
      </div>
      </div>
      </div>
      <!-- 右侧页签 -->
      <!--<tabBar></tabBar>-->
      </div>
      <!--<app-footer></app-footer>-->
      </el-container>
    </el-container>
  <!--</div>-->
  <!--</el-container>-->
  <!--</div>-->
</template>

<script>
  import AppHeader from '@/components/sub/Header.vue'
  import AppFooter from '@/components/sub/Footer.vue'
  import asideSet from '@/components/sub/asideSet.vue'
  import setBreadNav from '@/components/sub/setBreadNav.vue'
  import listBar from '@/components/sub/listBar.vue'
  import tabBar from '@/components/sub/tabBar.vue'
  import setComponent from "@/components/views/setBox/setComponent"
  import boxMail from "@/components/views/layout/boxMail"

  export default {
    name: 'layoutMainSetting',
    data () {
      return {
        breadcrumb: []
      }
    },
    components:{
      setComponent,
      asideSet,
      setBreadNav,
      tabBar,
      listBar,
      'app-header': AppHeader,
      'app-footer': AppFooter,
      boxMail
    },
    computed: {
      getBreadcrumb() {
        let navTitle = this.$route.meta.title;
        return navTitle.split('###');
      }
    },
    mounted() {
      let self = this;
      this.$EventBus.$off("updateBreadcrumb");
      this.$EventBus.$on("updateBreadcrumb",function(data){
        if(data && data.setBreadcrumb) {
          self.$route.meta.title = data.setBreadcrumb;
        }
      })
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      }
    }
  }
</script>

<style scoped>
  .wmCloudsWrapper{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: vertical;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/layout/MainSetting.vue